var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconoAlta = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.78338 13.8L4.53338 11.7333L2.18338 11.2L2.40005 8.79995L0.800049 6.99995L2.40005 5.19995L2.18338 2.79995L4.53338 2.26662L5.78338 0.199951L8.00005 1.14995L10.2167 0.199951L11.4667 2.26662L13.8167 2.79995L13.6 5.19995L15.2 6.99995L13.6 8.79995L13.8167 11.2L11.4667 11.7333L10.2167 13.8L8.00005 12.85L5.78338 13.8ZM6.26672 12.2833L8.00005 11.55L9.73338 12.2833L10.7 10.6666L12.5334 10.25L12.3667 8.39995L13.6 6.99995L12.3667 5.59995L12.5334 3.74995L10.7 3.33328L9.73338 1.71662L8.00005 2.44995L6.26672 1.71662L5.30005 3.33328L3.46672 3.73328L3.63338 5.59995L2.40005 6.99995L3.65005 8.39995L3.46672 10.2666L5.30005 10.6833L6.26672 12.2833ZM7.15005 9.39995L11.1167 5.44995L10.2667 4.59995L7.15005 7.69995L5.73338 6.29995L4.88338 7.14995L7.15005 9.39995Z",
    fill: "#2E6830"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconoAlta, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/icono_alta.c2dd311e.svg";
export { ForwardRef as ReactComponent };